// This icon file is generated automatically.
var PSkinOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M12.6.97H9.36a.6.6 0 00-.58.46 1.84 1.84 0 01-3.58 0 .6.6 0 00-.58-.46H1.4c-.38 0-.7.3-.7.69v3.93c0 .38.32.7.7.7h1.17v6.05c0 .38.3.7.69.7h7.46c.38 0 .7-.32.7-.7V6.28h1.16c.38 0 .7-.3.7-.69V1.66c0-.38-.32-.7-.7-.7zm-.44 4.19H10.3v6.75H3.7V5.16H1.84V2.09h2.4a2.97 2.97 0 005.52 0h2.4v3.07z", "fill-rule": "nonzero" } }] }, "name": "p-skin", "theme": "outlined" };
export default PSkinOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PSkinOutlined.js
// module id = 3632
// module chunks = 0